"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Select_1 = require("./Select");
exports.default = Select_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Select/index.js
// module id = 822
// module chunks = 8